import { ref } from 'vue'

export function useDssModal() {
  // State for a single modal (default use case)
  const isModalVisible = ref(false)

  // Object to track visibility of multiple modals by their IDs
  const modalsVisibility = ref({})

  /**
   * Show a modal.
   * If modalId is provided, shows the specific modal.
   * Otherwise, toggles the default modal visibility.
   * @param {string} [modalId] - Optional ID of the modal to show.
   */
  const showModal = (modalId) => {
    if (modalId) {
      modalsVisibility.value[modalId] = true
    }
    else {
      isModalVisible.value = true
    }
  }

  /**
   * Hide a modal.
   * If modalId is provided, hides the specific modal.
   * Otherwise, toggles the default modal visibility.
   * @param {string} [modalId] - Optional ID of the modal to hide.
   */
  const hideModal = (modalId) => {
    if (modalId) {
      modalsVisibility.value[modalId] = false
    }
    else {
      isModalVisible.value = false
    }
  }

  /**
   * Check if a modal is visible.
   * If modalId is provided, checks the specific modal.
   * Otherwise, checks the default modal visibility.
   * @param {string} [modalId] - Optional ID of the modal to check.
   * @returns {boolean} - The visibility state of the modal.
   */
  const isModalVisibleFunction = (modalId) => {
    if (modalId) {
      return !!modalsVisibility.value[modalId]
    }
    return isModalVisible.value
  }

  return {
    isModalVisible: isModalVisibleFunction,
    showModal,
    hideModal,
  }
}
